import { useState, useEffect } from 'react'

const STORAGE_KEY = 'at_intro_seen'

export default function IntroBanner() {
  const [visible, setVisible] = useState(false)
  const [animateIn, setAnimateIn] = useState(false)

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY)) return

    let triggered = false
    const trigger = () => {
      if (triggered) return
      triggered = true
      setVisible(true)
      setTimeout(() => setAnimateIn(true), 50)
    }

    const handleMouseLeave = (e) => {
      if (e.clientY <= 10) trigger()
    }

    const timer = setTimeout(trigger, 20000)

    document.addEventListener('mouseleave', handleMouseLeave)
    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave)
      clearTimeout(timer)
    }
  }, [])

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1')
    setAnimateIn(false)
    setTimeout(() => setVisible(false), 300)
  }

  if (!visible) return null

  return (
    <>
      <style>{`
        @keyframes banner-slide-up {
          from { transform: translateY(100%); }
          to { transform: translateY(0); }
        }
        .intro-banner {
          animation: banner-slide-up 0.4s cubic-bezier(0.22, 1, 0.36, 1) forwards;
        }
        .intro-banner-exit {
          animation: banner-slide-up 0.3s cubic-bezier(0.22, 1, 0.36, 1) reverse forwards;
        }
        @media (max-width: 600px) {
          .intro-banner-content { flex-direction: column; align-items: flex-start !important; gap: 14px !important; }
          .intro-banner-actions { width: 100%; justify-content: space-between; }
        }
      `}</style>
      <div className={animateIn ? 'intro-banner' : 'intro-banner-exit'} style={{
        position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 500,
        background: 'var(--pitch)', borderTop: '1px solid rgba(255,255,255,0.1)',
      }}>
        <div className="intro-banner-content" style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          gap: 20, padding: '18px clamp(20px,5vw,48px)', flexWrap: 'wrap',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
            <div style={{
              fontFamily: 'var(--f-d)', fontSize: 32, letterSpacing: '0.04em',
              color: 'var(--bone)', lineHeight: 1, flexShrink: 0,
            }}>
              £10 off
            </div>
            <div style={{
              fontSize: 13, fontWeight: 300, color: 'rgba(255,255,255,0.5)',
              lineHeight: 1.5,
            }}>
              your first session — any class, any format. Use code{' '}
              <strong style={{ color: 'rgba(255,255,255,0.75)', fontWeight: 400 }}>FIRST10</strong> at checkout.
            </div>
          </div>

          <div className="intro-banner-actions" style={{ display: 'flex', alignItems: 'center', gap: 16, flexShrink: 0 }}>
            <a href="#sessions" onClick={dismiss} style={{
              fontFamily: 'var(--f-m)', fontSize: 9, letterSpacing: '0.18em',
              textTransform: 'uppercase', padding: '11px 22px',
              background: 'var(--bone)', color: 'var(--pitch)',
              textDecoration: 'none', whiteSpace: 'nowrap',
              transition: 'background 0.2s',
            }}
              onMouseEnter={e => e.target.style.background = 'var(--ash)'}
              onMouseLeave={e => e.target.style.background = 'var(--bone)'}
            >
              Book now →
            </a>
            <button onClick={dismiss} style={{
              background: 'none', border: 'none', cursor: 'pointer',
              color: 'rgba(255,255,255,0.3)', fontSize: 18, padding: 4,
              lineHeight: 1, flexShrink: 0,
            }}>
              ✕
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
